<template>
  <v-menu
    ref="menu1"
    v-model="menu1"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        persistent-hint
        prepend-icon="event"
        placeholder="DD-MM-YYYY"
        @blur="date = parseDate(dateFormatted)"
        v-on="on"
        :rules="rules"
        :disabled="disabled"
        :dense="dense"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      @input="menu1 = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "DatePicker",
  props: {
    value: {
      default: "",
    },
    label: {
      default: "Date",
    },
    timestamp: {
      default: false,
    },
    disabled: {
      default: false,
    },
    dense: {
      default: false,
    },
    timezone: {
      default: null,
    },
    offset: {
      default: null,
    },
    autoSelect: {
      default: false,
    },
    rules: {
      default: () => [],
    },
  },
})
export default class DatePicker extends (Vue, Themeable) {
  dateFormatted = null;
  menu1 = false;
  date = "";
  time = null;
  timezoneOffset = new Date().getTimezoneOffset() * 60;

  mounted() {
    this.timezoneOffset =
      this.offset == null ? new Date().getTimezoneOffset() * 60 : this.offset;

    if (this.autoSelect !== false && this.value == null) {
      const dateObj = new Date();
      const month = dateObj.getUTCMonth() + 1; //months from 1-12
      const day = dateObj.getDate();
      const year = dateObj.getUTCFullYear();

      this.onValueChange(year * 10000 + month * 100 + day);
    } else this.onValueChange(this.value);
  }

  @Watch("offset")
  onOffsetChange(val) {
    this.timezoneOffset =
      val == null ? new Date().getTimezoneOffset() * 60 : val;
  }

  @Watch("date")
  onDateChange(val, oldValue) {
    if (val === oldValue) return;
    this.dateFormatted = this.formatDate(val);
    if (val != null && val != "") {
      if (this.timestamp === false)
        this.$emit("input", this.formatDateToInt(val));
      else this.$emit("input", this.getTime(val, this.time));
    } else {
      this.time = null;
      this.$emit("input", null);
    }
  }

  @Watch("value", { immediate: true })
  onValueChange(value, oldValue) {
    if (value === oldValue) return;
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      (Number.isInteger(value) &&
        value.toString().length != 8 &&
        this.timestamp === false)
    ) {
      if (this.autoSelect !== false) {
        const dateObj = new Date();
        const month = dateObj.getUTCMonth() + 1; //months from 1-12
        const day = dateObj.getDate();
        const year = dateObj.getUTCFullYear();

        value = year * 10000 + month * 100 + day;
        this.$emit("input", value);
      } else {
        this.dateFormatted = null;
        return;
      }
    }
    const dateStr =
      this.timestamp === false ? value.toString() : this.getDate(value);

    this.dateFormatted =
      dateStr.substring(6, 8) +
      "-" +
      dateStr.substring(4, 6) +
      "-" +
      dateStr.substring(0, 4);
  }

  formatDateToInt(date) {
    if (!date) return null;
    const [year, month, day] = date.split("-");
    return parseInt(`${year}${month}${day}`);
  }

  formatDate(date) {
    if (!date) return null;
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  }

  parseDate(date) {
    if (!date) return null;

    const [day, month, year] = date.split("-");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  getDate(value) {
    if (value == null) {
      return null;
    }
    value = value * 1000 - this.timezoneOffset * 1000;
    this.time = this.$moment(value).toISOString().substring(10);
    return this.$moment(value).format("YYYYMMDD");
  }

  getTime(dt, time) {
    const a = this.$moment(dt + (time ? time : "T00:00:00.000Z")).format("X");
    return parseInt(a) + this.timezoneOffset;
  }
}
</script>
